import React from 'react';
export const HeaderItems = {
  TAB: 'tab',
  DROPDOWN: 'dropdown',
  NOTIFICATION: 'notification'
};
export const getOrganisationLogo = _ref => {
  let {
    imageUrl,
    svg
  } = _ref;
  let logo = null;
  if (imageUrl) {
    logo = /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      alt: "logo",
      loading: "lazy",
      className: "organization__logo__img"
    });
  } else if (svg) {
    logo = /*#__PURE__*/React.cloneElement(svg, {
      className: 'organization__logo'
    });
  }
  return logo;
};